import api from '@/lib/api'

const state = () => ({
  me: { 
    address: {
      street: '',
      city: '',
      state: '',
      zipcode: '',
    },
    settings: {
      expand_network: true,
      user_split_pct: 100,
      rewards_beta: false,
    },
  },

  w9: null,
  w9Progress: null,
})

const getters = {
  me: state => state.me,
  w9: state => state.w9,
  w9Progress: state => state.w9Progress,
}

const actions = { 
  async loadMe({ commit }) {
    const result = await api.get('/account')
    if (result.ok) {
      const me = await result.json()
      commit('SET_ME', me)
      return { ok: true, fetched: me }
    }
    
    return { ...await result.json(), status: result.status, ok: false }
  },

  async updateMe({ commit }, me) {
    const result = await api.put('/account', { me })
    if (result.ok) {
      const me = await result.json()
      commit('SET_ME', me)
      return { ok: true, updated: me }
    }
    
    return { ...await result.json(), status: result.status, ok: false }
  },

  async saveW9Progress({ commit }, progress) { 
    commit('SET_W9_PROGRESS', progress)

    return { ok: true }
  },

  // eslint-disable-next-line no-empty-pattern
  async createW9({ }, { name, business_name, street, city, state, zipcode, business_type, ein, signature }) {
    const payload = {
      w9: { name, business_name, street, city, state, zipcode, business_type, ein, signature },
    }
    
    const result = await api.post('/account/w9s', payload)
    if (result.ok) {
      return { ok: true }
    }

    return { ...await result.json(), status: result.status, ok: false }
  },

  async loadW9({ commit }) {
    const result = await api.get('/account/w9s/most_recent')
    if (result.ok) {
      commit('SET_W9', await result.json())
      return { ok: true }
    }
    
    commit('SET_W9', null)
    return { ...await result.json(), status: result.status, ok: false }
  },
}

const mutations = { 
  SET_ME: (state, me) => state.me = me,
  SET_W9: (state, w9) => state.w9 = w9,
  SET_W9_PROGRESS: (state, larvalW9) => state.w9Progress = larvalW9,
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}